export default __webpack_public_path__ + "static/media/bubble.54ba5c11.svg";